<template>
  <div class="subscription-box text-center">
    <p class="title text-left">
      <span>{{ $t('subscription') }}</span>
      <span class="un-subscribe" v-if="subscriptionInfo.status === 'active' && subscriptionInfo.payment_method_name !== 'iTunes'" data-toggle="modal" data-target="#cancel-subscription">{{ $t('cancelSubscription') }}</span>
    </p>

    <template v-if="subscriptionInfo.status === 'active'">
      <template v-if="subscriptionInfo.payment_method_name === 'iTunes'">
        <p class="itunes-subscribe">{{ $t('itunesSubscribe') }}</p>
      </template>
      <template v-else>
        <p class="subscription-package">{{ $t('subscriptionPackage') }}{{ subscriptionInfo.package_detail.name }}</p>
        <p class="payment-info">{{ $t('paymentMethod') }}{{ subscriptionInfo.payment_method_name }}</p>
      </template>
    </template>
    <p v-else class="no-subscription">{{ $t('noSubscription') }}<router-link to="/dashboard">{{ $t('goToSubscription') }}</router-link>{{ $t('modalParticle') }}</p>

    <p class="declaration">{{ $t('declaration') }}</p>
    <p class="declaration-list" v-for="(item, index) in $t('declarationList')"><span class="index">{{ index +1 }}</span> {{ item }}</p>

    <cancel-subscription :subscriptionInfo="subscriptionInfo"></cancel-subscription>
  </div>
</template>

<script>
  import cancelSubscription from '../cancelSubscription/Index.vue'
  import locales from './lang'

  export default {
    name: 'subscription',
    components: {cancelSubscription},
    locales,
    computed: {
      subscriptionInfo() {
        return this.$store.state.subscribe.subscriptionInfo
      }
    },
    created() {
      this.$store.dispatch('getSubscription')
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  .subscription-box {
    padding: 0 0 .2rem 0;
  }

  p {
    padding: 0 .4rem;
    margin: 0;
  }

  .title {
    padding: 0 .16rem;
    border-bottom: .01rem solid rgba(224,215,227,1);
    line-height: .48rem;
    height: .48rem;
    display: block;
    span {
      line-height: .48rem;
      height: .48rem;
      border-bottom: .01rem solid transparent;
      color: #111;
      display: inline-block;
      font-size: .16rem;
    }
    .un-subscribe {
      text-align: center;
      cursor: pointer;
      font-size: .14rem;
      color: #666666;
      width: 1.05rem;
      height: .28rem;
      line-height: .28rem;
      float: right;
      border: 1px solid #E0D7E3;
      border-radius: 4px;
      margin-top: 0.1rem;
    }
    @media screen and (max-width: 767px) {
      line-height: .44rem;
      height: .44rem;
      span {
        line-height: .44rem;
        height: .44rem;
        font-size: .14rem;
      }
      .un-subscribe {
        width: .92rem;
        height: .28rem;
        font-size: .12rem;
        margin-top: .08rem;
      }
    }
  }

  .no-subscription {
    clear: both;
    color: #333;
    font-size: .2rem;
    font-weight: 600;
    line-height: .2rem;
    letter-spacing: 0.7px;
    margin: .8rem 0 .6rem;
    a {
      color: $base-blue;
      text-decoration: none;
      &:focus {
        color: $base-blue;
      }
    }
  }

  .itunes-subscribe {
    clear: both;
    color: #333;
    font-size: 20px;
    letter-spacing: 0.7px;
    line-height: 20px;
    font-weight: 600;
    margin: .8rem 0 .6rem;
    @media screen and (max-width: 767px) {
      margin: .24rem 0;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.63px;
    }
  }

  .payment-info {
    color: #333;
    clear: both;
    font-size: .2rem;
    letter-spacing: 0.7px;
    font-weight: 600;
    margin-bottom: .6rem;
  }

  .subscription-package {
    margin: .8rem 0 .16rem;
    color: #333;
    clear: both;
    font-size: .2rem;
    letter-spacing: 0.7px;
    font-weight: 600;
  }

  .declaration, .declaration-list {
    color: #333;
    font-size: .14rem;
    line-height: .16rem;
  }

  .declaration {
    margin-bottom: .16rem;
  }

  .declaration-list {
    clear: both;
    padding-top: .24rem;
    color: #666;
    font-size: .14rem;
    letter-spacing: 0;
    line-height: .2rem;
    span.index {
      border: 1px solid #999;
      border-radius: 16px;
      width: 16px;
      height: 16px;
      line-height: .14rem;
      display: inline-block;
      text-align: center;
      &:nth-child(2) {
        margin: 0 .08rem 0 .08rem;
      }
    }
    span.describe-notice {
      color: #5a5a5a;
    }
  }

  @media (max-width: 767px) {
    .no-subscription {
      width: 80%;
      margin: .24rem auto;
      font-size: .18rem;
      line-height: .24rem;
      letter-spacing: 0.63px;
    }
    .declaration {
      font-size: .12rem;
      color: #666;
      margin-bottom: 0;
    }
    .declaration-list {
      padding: .16rem .16rem 0;
      font-size: .12rem;
      span.index {
        border-radius: 14px;
        width: 14px;
        height: 14px;
        line-height: .12rem;
      }
    }
    .payment-info {
      font-size: .18rem;
      letter-spacing: 0.63px;
      line-height: .24rem;
      margin-bottom: .24rem;
    }
    .subscription-package {
      margin: .24rem 0 .08rem;
      font-size: .18rem;
      letter-spacing: 0.63px;
      line-height: .24rem;
    }
  }

</style>



// WEBPACK FOOTER //
// Index.vue?8eabeeee